module.exports = __webpack_public_path__ + "img/rankB.b91f0ac2.svg";